@for (block of outputs; track trackByIndex($index)) {
  @if (block.type === AnalystOutputType.Table && block.table) {
    <app-analyst-table [table]="block.table" [citationNumbering]="citationNumbering"></app-analyst-table>
  }
  @if (block.type === AnalystOutputType.Chart && block.chart) {
    <app-analyst-chart [chart]="block.chart" [citationNumbering]="citationNumbering"></app-analyst-chart>
  }
}
@if (citationNumbering.sources.length) {
  <app-analyst-sources [sources]="citationNumbering.sources"></app-analyst-sources>
}
@if (clarifications.length) {
  <app-analyst-clarification [clarifications]="clarifications" [disabled]="disabled"
    [answered]="clarificationAnswered" [answeredText]="clarificationAnswerText"
  (optionSelected)="optionSelected.emit($event)"></app-analyst-clarification>
}
@if (narrowingOptions) {
  <app-analyst-narrowing-options [narrowingOptions]="narrowingOptions" [disabled]="disabled"
    [answered]="clarificationAnswered" [answeredText]="clarificationAnswerText"
  (optionSelected)="optionSelected.emit($event)"></app-analyst-narrowing-options>
}
